<template>
  <Button
    href="https://github.com/baserow/baserow"
    tag="a"
    target="_blank"
    class="github-star-button"
    :class="{ 'github-star-button--in-header': inHeader }"
    type="secondary"
    :size="size"
    :full-width="fullWidth"
    title="Navigate to the Baserow repository on GitHub"
  >
    <i class="github-star-button__github-icon iconoir-github-circle"></i>
    <span class="github-star-button__text">{{ text }}</span>
    <i class="github-star-button__star-icon iconoir-star"></i>
    <span class="github-star-button__stars">6.2k</span>
  </Button>
</template>

<script>
export default {
  name: 'GithubStarButton',
  props: {
    inHeader: {
      type: Boolean,
      required: false,
      default: false,
    },
    size: {
      type: String,
      required: false,
      default: 'regular',
    },
    fullWidth: {
      type: Boolean,
      required: false,
      default: false,
    },
    text: {
      type: String,
      required: false,
      default: 'GitHub',
    },
  },
}
</script>
